module.exports = __webpack_public_path__ + "075d3a3b3b185132b8670e4054446080.png";